<template>
  <div id="app" class="app-wrapper">
    <el-scrollbar>
      <div class="sn-union-ctn bbx clearfix">
        <!-- 左侧导航区域 -->
        <left-menu></left-menu>
        <div class="sn-union-right">
          <!-- 顶部导航区域 -->
          <header-menu></header-menu>
          <!--主体内容区域-->
            <router-view></router-view>
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import LeftMenu from "@/components/LeftMenu"
import HeaderMenu from "@/components/HeaderMenu"
export default {
  name: "App",
  components: {
    LeftMenu,
    HeaderMenu
  },
};
</script>
<style lang="scss">
.app-wrapper{
  .el-scrollbar__thumb{
    margin-top: 136px;
  }
}
</style>




